<template>
  <div>
    <Modal
      v-model="show"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" inline :label-width="130" label-colon>
          <div class="item">
            <FormItem :label="$t('mail_code')" prop="set_code">
              <Select v-model="form.set_code" :placeholder="$t('mail_code_input')">
                <Option v-for="item in codeList" :value="item.key" :key="item.key">{{ item.value }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('mail_user_name')" prop="mail_user_name">
              <Input
                type="text"
                v-model="form.mail_user_name"
                :placeholder="$t('mail_user_name_input')"
              ></Input>
            </FormItem>
            <FormItem :label="$t('mail_password')" prop="mail_password">
              <Input
                type="text"
                v-model="form.mail_password"
                :placeholder="$t('mail_password_input')"
              ></Input>
            </FormItem>
            <FormItem :label="$t('mail_per_day')" prop="mail_per_day">
              <InputNumber
                :min="1"
                v-model="form.mail_per_day"
                :placeholder="$t('mail_per_day_input')"
              ></InputNumber>
            </FormItem>
            <FormItem prop="mail_per_hour" :label="$t('mail_per_hour')">
              <InputNumber
                :min="1"
                v-model="form.mail_per_hour"
                :placeholder="$t('mail_per_day_input')"
              ></InputNumber>
            </FormItem>
            <FormItem prop="mail_per_minute" :label="$t('mail_per_minute')">
              <InputNumber
                :min="1"
                v-model="form.mail_per_minute"
                :placeholder="$t('mail_per_minute_input')"
              ></InputNumber>
            </FormItem>
            <FormItem :label="$t('default_status')" prop="default_status">
              <i-Switch size="large" v-model="form.default_status" true-value="1" false-value="0" />
            </FormItem>
          </div>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String
  },
  data () {
    return {
      form: {
        set_code: null,
        mail_user_name: "",
        mail_password: "",
        mail_per_day: null,
        mail_per_hour: null,
        mail_per_minute: null,
        default_status: '0',
      },
      ruleInline: {
        set_code: [
          { required: true, message: this.$t("mail_code_input"), trigger: 'change' }
        ],
        mail_user_name: [
          {
            required: true,
            message: this.$t("mail_user_name_input"),
            trigger: "blur"
          },
          { type: 'email', message: this.$t('email_error'), trigger: 'blur' }
        ],
        mail_password: [
          {
            required: true,
            message: this.$t("mail_password_input"),
            trigger: "blur"
          }
        ],
        mail_per_day: [
          {
            type: 'number',
            required: true,
            message: this.$t("mail_per_day_input"),
            trigger: "blur"
          }
        ],
        mail_per_hour: [
          {
            type: 'number',
            required: true,
            message: this.$t("mail_per_hour_input"),
            trigger: "blur"
          }
        ],
        mail_per_minute: [
          {
            type: 'number',
            required: true,
            message: this.$t("mail_per_minute_input"),
            trigger: "blur"
          }
        ],
        default_status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
      },
      show: this.modal,
      codeList: [],
    }

  },
  created () {
    this.setCode();
    this.info();
  },
  mounted () {

  },
  methods: {
    setCode () {
      this.$base.showLoading();
      this.$request.sendPost(
        'sys_email/before-add', {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.codeList = data.codes
        }
      );

    },
    info () {
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'sys_email/before-upd',
          { set_id: this.itemObj.set_id },
          (success, data, error) => {
            this.$base.hideLoading();
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info
            this.form.mail_per_day = this.form.mail_per_day * 1
            this.form.mail_per_hour = this.form.mail_per_hour * 1
            this.form.mail_per_minute = this.form.mail_per_minute * 1
          }
        );
      }
    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'sys_email/add' : 'sys_email/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .ivu-tabs .ivu-tabs-tabpane {
    margin-top: 40px;
  }
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 0 0 20px 10%;
  }
  .tabs_item {
    width: 80%;
    margin: 20px 0 0 10%;
    .item_input {
      width: 100%;
      padding-right: 10px;
    }
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 150px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/mailSetup/module/mailSetup_edit.vue